import React from 'react';
import imgLogin from '../../assets/images/logo_login.png';
import { AuthToken, AuthLogin } from '../../lib/MyHttp';

class Login extends React.Component {
    constructor(props) {
        super(props);

        const id = localStorage.getItem('login_id');

        this.state = {
            id: id,
            pwd: '',
            role: 'ADMIN',
            loading: false,
            autoSave: id,
        };
    }

    clickLogin = () => {
        const { id, pwd, role } = this.state;
        if (id === '') {
            alert('아이디를 입력해주세요.');
            return;
        }

        if (pwd === '') {
            alert('패스워드를 입력해주세요.');
            return;
        }

        localStorage.setItem('access_token', '');
        localStorage.setItem('refresh_token', '');
        AuthLogin(this, id, pwd, role, this.resultLogin, this.resultFail);
    };

    /**
     * 로그인 성공
     */
    resultLogin = response => {
        if (this.state.autoSave) {
            localStorage.setItem('login_id', this.state.id);
        } else {
            localStorage.setItem('login_id', '');
        }

        localStorage.setItem('id', response['id']);
        localStorage.setItem('role', response['role']);
        localStorage.setItem('name', response['name']);
        localStorage.setItem('email', response['email']);

        window.location = '/a/home/info';
    };

    resultFail = response => {
        alert(response.response.data.message);
    };

    changeInput = e => {
        const { value, name } = e.target;
        this.setState({ [name]: value });
    };

    render() {
        const { role } = this.state;

        return (
            <>
                <div id="login_wrap">
                    <div class="inner">
                        <div class="logo_box">
                            <img src={imgLogin} alt="로고" />
                        </div>

                        <div className="t_btns_box">
                            <a href="javascript:;" className={role === 'ADMIN' ? 'in_btn active' : 'in_btn'} onClick={e => this.setState({ role: 'ADMIN' })}>
                                대표운영자
                            </a>
                            <a href="javascript:;" className={role === 'BRANCH' ? 'in_btn active' : 'in_btn'} onClick={e => this.setState({ role: 'BRANCH' })}>
                                지사운영자
                            </a>
                        </div>

                        <div class="login_form_box">
                            <div class="row1">
                                <label class="log_label" id="loginId">
                                    아이디
                                </label>
                                <input
                                    type="text"
                                    class="login_txt"
                                    id="loginId"
                                    onChange={this.changeInput}
                                    value={this.state.id}
                                    placeholder="아이디를 입력해 주세요."
                                    name="id"
                                    onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                            this.clickLogin(e);
                                        }
                                    }}
                                />
                            </div>
                            <div class="row1">
                                <label class="log_label" id="loginPwd">
                                    비밀번호
                                </label>
                                <input
                                    type="password"
                                    class="login_txt"
                                    id="loginPwd"
                                    onChange={this.changeInput}
                                    name="pwd"
                                    value={this.state.pwd}
                                    placeholder="비밀번호를 입력해주세요."
                                    onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                            this.clickLogin(e);
                                        }
                                    }}
                                />
                            </div>
                            <div class="save_box">
                                <div class="lb">
                                    <input
                                        type="checkbox"
                                        class="saveCheck"
                                        name="checkbox-fill-1"
                                        id="checkbox-fill-a1"
                                        checked={this.state.autoSave}
                                        onChange={e => {
                                            this.setState({ autoSave: e.target.checked });
                                        }}
                                    />{' '}
                                    <label htmlFor="checkbox-fill-a1" className="cr">
                                        <span></span> 아이디 기억하기
                                    </label>
                                </div>
                                {/* <div class="rb">
                                    <a href="/auth/resetpwd">비밀번호 찾기</a>
                                </div> */}
                            </div>
                        </div>

                        <div class="btn_box">
                            <button class="btn_login" title="로그인" onClick={this.clickLogin}>
                                {this.state.loading ? (
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ margin: 'auto' }}>{/* <ReactLoading type={'spin'} color={'#aaa'} height={30} width={30} /> */}</div>
                                    </div>
                                ) : (
                                    '로그인'
                                )}
                            </button>
                        </div>

                        <div className="addr_box">
                            <address>
                                <p>
                                    한국분동 주식회사 / 주소 경기도 광주시 초월읍 무들로 147번길 22-26 / 전화번호(전국대표) 1577-7368, <br />
                                    (본사) 031-761-7090 / 팩스번호 031-761-7091, 031-761-7094/ 이메일 HKBUNDONG@NAVER.COM
                                </p>
                                <span>COPYRIGHT 2021 KOREA WEIGHT. ALL RIGHTS RESERVED</span>
                            </address>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Login;
